import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.unmatch-match.views.MatchedStatementItemsList`

export default defineMessages({
  description: {
    id: `${scope}.description`,
    defaultMessage:
      'The following statement item(s) are matched with this transaction. Unmatching returns them to the unmatched panes.',
  },
})
